var memoizePromiseFn = function memoizePromiseFn(fn) {
  var cache = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var key = JSON.stringify(args);

    if (cache.has(key)) {
      return cache.get(key);
    }

    cache.set(key, fn([].concat(args))["catch"](function (error) {
      // Delete cache entry if api call fails
      cache["delete"](key);
      return Promise.reject(error);
    }));
    return cache.get(key);
  };
};

export default memoizePromiseFn;
//# sourceMappingURL=memoize-promise-fn.esm.js.map
